// Regnskapsbyra-flaten (no).
//
// Nye byraastrenger hoerer hjemme her. De eldre `rf.*`-noeklene ligger fortsatt i
// locale-no.js og flyttes hit naar de likevel roeres.
window.PlummeI18n.register('no', {
  // ---------------------------------------------------- Lasting i byraaflaten
  // «Laster regnskapet ditt …» er kundeappens tekst. I byraaflaten er det ikke
  // ditt regnskap som lastes, og som regel ikke et regnskap i det hele tatt.
  'rf.loading.firm': 'Laster byrået ditt …',
  'rf.loading.clients': 'Henter klientene dine …',
  'rf.loading.reconciliation': 'Henter avstemmingene …',
  'rf.loading.control': 'Henter kontrolloppgavene …',
  'rf.loading.ledger': 'Laster klientens regnskap …',
  'rf.pageError.title': 'Siden kunne ikke lastes',
  'rf.pageError.text': 'Last byråflaten på nytt. Vedvarer det, er skriptet for denne siden utilgjengelig.',
  // ------------------------------------------------- Tildeling paa oppdraget
  // Flere av gangen, og «alle i byraaet» som eget valg: et lite byraa setter ofte
  // hele huset paa hver klient, og en klient har uansett flere roller besatt.
  'rf.client.assignCount': 'Sett på ({count})',
  'rf.client.assignAll': 'Alle i byrået',
  'rf.client.assignNobody': 'Byrået har ingen aktive medarbeidere å sette på oppdraget ennå.',
  'rf.client.assignRoleHint': 'Rollen gjelder alle du har krysset av. Er noen satt på fra før, får de den nye rollen.',
  'rf.client.assignedMany': '{count} medarbeidere er satt på oppdraget',
  // ------------------------------------------------------------ Navigasjon ut
  // Min side er brukerens egen konto, og samtidig veien ut av byraaflaten.
  // «Til byraaets regnskap» vises bare naar byraaet fores i Plumme selv.
  'rf.nav.myPage': 'Min side',
  'rf.nav.firmBooks': 'Til byråets regnskap',
});
